import { render, staticRenderFns } from "./WaterQuality.vue?vue&type=template&id=01b34695&scoped=true"
import script from "./WaterQuality.vue?vue&type=script&lang=js"
export * from "./WaterQuality.vue?vue&type=script&lang=js"
import style0 from "./WaterQuality.vue?vue&type=style&index=0&id=01b34695&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b34695",
  null
  
)

export default component.exports